<template>
  <div>
    <modal @close="closeCaptureModal" :show.sync="showCam" headerclasses="justify-content-center" :showClose="false" modalClasses="capture-modal m-0 d-flex h-100" bodyClasses="d-flex p-0" footerClasses="d-none">
      <div style="flex: 1;position: relative">

        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }" style="height: calc(100% - 82px)">

          <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

          <video v-show="!isPhotoTaken" ref="video" autoplay style="width: 100vw;height: 100vh;object-fit: cover;"></video>
          <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas"></canvas>
        </div>

        <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
          <n-button type="primary" round @click.native="closeCaptureModal" icon size="lg">
            <i class="fas fa-times"></i>
          </n-button>

          <n-button type="primary" round @click.native="saveImage" icon size="lg" v-if="isPhotoTaken">
            <i class="fas fa-check"></i>
          </n-button>

          <n-button type="primary" round @click.native="takePhoto" icon size="lg" v-if="!isPhotoTaken">
            <i class="fas fa-camera"></i>
          </n-button>

          <n-button type="primary" round @click.native="createCameraElement" icon size="lg" v-if="isPhotoTaken">
            <i class="fas fa-undo"></i>
          </n-button>

          <n-button type="primary" round @click.native="switchCamera" icon size="lg" v-if="!isPhotoTaken">
            <i class="fas fa-sync-alt"></i>
          </n-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "app-camera",

  components: {},

  data() {
    return {
      videoConstraints: {
        facingMode: "environment",
        width: { ideal: 4096 },
        height: { ideal: 2160 },
      },
      cameraStream: null,
      isCameraOpen: true,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
    };
  },

  props: ["showCam"],

  computed: {},

  methods: {
    closeCaptureModal() {
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }

      this.isPhotoTaken = false;

      this.$emit("closeCamera");
    },
    async saveImage() {
      let fileData = this.$refs.canvas
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");

      this.closeCaptureModal();
      this.$emit("imageCaptured", fileData);
    },
    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      this.$refs.canvas.width = this.$refs.video.videoWidth;
      this.$refs.canvas.height = this.$refs.video.videoHeight;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(
        this.$refs.video,
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
    },
    createCameraElement() {
      let that = this;
      this.isLoading = true;
      this.isPhotoTaken = false;

      const constraints = {
        audio: false,
        video: this.videoConstraints,
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          that.isLoading = false;
          that.cameraStream = stream;
          that.$refs.video.srcObject = stream;
        })
        .catch((error) => {
          console.log(error);
          that.isLoading = false;
          that.switchCamera();
          //alert("May the browser didn't support or there is some errors.");
        });
    },
    switchCamera() {
      let that = this;
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      this.videoConstraints.facingMode =
        this.videoConstraints.facingMode == "environment"
          ? "user"
          : "environment";

      var mediaConstraints = {
        audio: false,
        video: this.videoConstraints,
      };

      navigator.mediaDevices
        .getUserMedia(mediaConstraints)
        .then(function (stream) {
          that.isLoading = false;
          that.cameraStream = stream;
          that.$refs.video.srcObject = stream;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.camera-shoot {
  display: flex;
  place-content: center;
  position: absolute;
  bottom: 0px;
  inset-inline-end: 50%;
  transform: translateX(50%);
  width: 100%;
  justify-content: space-around;
}
[dir="rtl"] .camera-shoot {
  transform: translateX(-50%);
}

.camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
  border: 0 px;
  height: 100%;
}
.camera-shutter.flash {
  opacity: 1;
}

/deep/.capture-modal .modal-body {
  min-height: 90vh;
}
/deep/.capture-modal .modal-header {
  display: none;
}
</style>
